module.exports = __webpack_public_path__ + "static/media/primary-background.d2c1ffdc.jpg";